/**
 * This file sets up charts through the entire application.
 * See https://stackoverflow.com/questions/67727603/error-category-is-not-a-registered-scale for more details
 */
import { Chart as ChartJS, registerables } from 'chart.js';

ChartJS.register(...registerables);
